<a href="#main-content" class="govuk-skip-link" data-module="govuk-skip-link" (click)="skipToMainContent($event)">Skip to main content</a>

<ui-timeout></ui-timeout>
<app-header></app-header>

<!-- <app-skip-to-content></app-skip-to-content> -->

<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="ball-beat"
  [fullScreen]="true"
>
  <p style="color: white">Processing... Please Wait</p>
</ngx-spinner>
<main
  class="govuk-main-wrapper govuk-main-wrapper--l"
  role="main"
  tabindex="-1"
>
  <alert role="alert" aria-live="polite"></alert>
  <router-outlet></router-outlet>
</main>


<app-footer></app-footer>
